export enum TipoAgendamentoPedido {
    "NENHUM" = "NENHUM",
    "DATA" = "DATA",
    "HORA" = "HORA",
    "DATA_E_HORA" = "DATA_E_HORA"
}

export enum TipoAgendamentoPedidoTitulo {
    "NENHUM" = "Sem agendamento",
    "DATA" = "Apenas data",
    "HORA" = "Apenas hora",
    "DATA_E_HORA" = "Data e hora"
}

export enum TipoAgendamentoPedidoDescricao {
    "NENHUM" = "Pedidos não terão opção de agendamento no checkout.",
    "DATA" = "Cliente poderá informar uma data para o pedido.",
    "HORA" = "Cliente poderá informar um horário para o pedido.",
    "DATA_E_HORA" = "Cliente poderá informar data e horário para o pedido."
}
